import { Image, Link } from '@alto-avios/alto-ui';
import { mergeProps } from '@react-aria/utils';
import { clsx } from 'clsx';
import { ComponentProps, FC } from 'react';

import { pushGTMEvent } from '../../utilities';

import styles from './Logo.module.scss';

export interface LogoProps extends ComponentProps<typeof Link> {
  imageData: {
    alt: string;
    ariaLabel: string;
    image: string;
    url: string;
  };
  variant: 'header' | 'footer';
}

export const Logo: FC<LogoProps> = ({ imageData: { alt, ariaLabel, image, url }, variant, ...props }) => {
  return (
    <Link
      aria-label={ariaLabel}
      className={clsx(styles.logo, styles[variant])}
      href={url}
      iconEndProps={false}
      {...mergeProps(props, { onPress: () => pushGTMEvent(variant, 'Avios logo') })}
    >
      <Image alt={alt} src={image} />
    </Link>
  );
};
